/**
 * Type definition of how an ease is stored: array of 4 numbers.
 */

/**
 * Ease List curves in Array format.
 * Accepts an EaseName and returns an array of 4 numbers.
 * @param {string} EaseName
 * @returns {array} EaseCurve
 */
export var eases = {
  primary: [0.5, 0, 0, 1],
  accelerate: [0.5, 0, 1, 1],
  decelerate: [0, 0, 0.3, 1],
  easeDamp: [0.02, 0.85, 0.01, 0.98],
  easeOutQuint: [0.23, 1, 0.32, 1],
  easeInOutQuint: [0.7, 0, 0.05, 1]
};
/**
 * Type definition for EaseName
 * Helpful if you are being strict about accepting not just a string but a specific ease name.
 */

/**
 * This function will return a `cubic-bezier(x1,y1,x2,y2)` for use in css from an array of 4 numbers.
 * @param {array} EaseCurve
 * @returns {string} 'cubic-bezier(x1,y1,x2,y2)'
 */

export var cubicBezierEase = function cubicBezierEase(list) {
  return "cubic-bezier(".concat(list.join(', '), ")");
};
/**
 *
 * @todo performance test use of Proxy(). Replace with {easeName: string} for performance.
 *
 * Abstracts the ease list for generating CSS usable "ease"(s)
 * in cubic-bezier(x1, y1, x2, y2).
 *
 * Accepts an EaseName and returns a string cubic-bezier() for css.
 *
 * @param {string} EaseName
 * @returns {string} 'cubic-bezier(x1,y1,x2,y2)'
 */

export var easeCurves = {
  /** @deprecated use theme.transitions.eases.primary instead. */
  primary: cubicBezierEase(eases.primary),

  /** @deprecated use theme.transitions.eases.easeIn instead. */
  accelerate: cubicBezierEase(eases.accelerate),

  /** @deprecated use theme.transitions.eases.easeOut instead. */
  decelerate: cubicBezierEase(eases.decelerate),

  /** @deprecated use theme.transitions.eases instead. */
  easeDamp: cubicBezierEase(eases.easeDamp),

  /** @deprecated use theme.transitions.eases instead. */
  easeOutQuint: cubicBezierEase(eases.easeOutQuint),

  /** @deprecated use theme.transitions.eases instead. */
  easeInOutQuint: cubicBezierEase(eases.easeInOutQuint)
};